module.exports = __webpack_public_path__ + "static/media/study 210818.9ba1aefd.png";